<script>
import { nextTick } from 'vue';
import { createBigTask, updateBigTask, deleteBigTask } from '@/services/BigTaskServices';

export default {
  props: [ 'propBigTask' ],
  components: {},
  data() { 
    return {
      // Big Task object
      bigTask: null, // title, description, stacked, dateCreated, dateUpdated
      // form inputs
      bigTaskTitle: '',
      bigTaskDescription: '',
    };
  },
  computed: {
    bigTaskFromStore() {
      return this.$store.getters['program/todaysBigTask'];
    },
    uId() {
      return this.$store.getters['uId'];
    },
    token() {
      return this.$store.getters['token'];
    },
    today() {
      return this.$store.getters['today'];
    },
    todayActual() {
      return this.$store.getters['todayActual'];
    },
  },
  methods: {
    async saveBigTask() {
      const newBigTask = {
        title: this.bigTaskTitle.trim(),
        description: this.bigTaskDescription.trim(),
        stacked: false,
        dateCreated: this.todayActual,
        dateUpdated: this.todayActual,
      };
      console.log('*** saveBigTask() ***', newBigTask);

      const bigTaskWasCreated = await createBigTask(this.uId, this.token, this.today, newBigTask); // returns true if successful, or throws error
      if (bigTaskWasCreated) {
        this.bigTask = newBigTask;
        this.bigTaskTitle = this.bigTask.title ? this.bigTask.title : '';
        this.bigTaskDescription = this.bigTask.description ? this.bigTask.description : '';
      }
    },

    async stackBigTask(newStatus) {
      const updatedBigTask = {
        title: this.bigTask.title,
        description: this.bigTask.description,
        stacked: newStatus,
        dateCreated: this.bigTask.dateCreated,
        dateUpdated: this.todayActual,
      };
      const didItUpdate = await updateBigTask(this.uId, this.token, this.today, updatedBigTask);
      if (didItUpdate) {
        this.bigTask = updatedBigTask;
      }
    },

    async editBigTask() {
      this.bigTask.title = this.bigTask.description = '';

      await nextTick();
      document.getElementById('big-task-title-input').click();
    },

    async deleteBigTask() {
      await deleteBigTask(this.uId, this.token, this.today);
      await nextTick();
      window.location.reload();
    },


  },
  created() {
    this.bigTask = { ...this.propBigTask };
    this.bigTaskTitle = this.bigTask.title ? this.bigTask.title : '';
    this.bigTaskDescription = this.bigTask.description ? this.bigTask.description : '';
  },
};
</script>

<template>
  <div id="section-big-task-for-today" class="mt-12 mb-5">
    <h2 class="mb-2"><u>BIG TASK for today</u></h2>


    <!-- if yes big task -->
    <div v-if="bigTask.title">
      <v-card class="d-flex mt-3" variant="flat">

        <v-icon v-if="!!bigTask.stacked" @click.prevent="stackBigTask(false)"
                class="mr-2"
        >mdi-checkbox-marked-outline</v-icon>
        <v-icon v-else @click.prevent="stackBigTask(true)"
                class="mr-2"
        >mdi-checkbox-blank-outline</v-icon>


        <div class="w-100 d-flex justify-space-between align-start">
          <p class="one-big-task" :class="bigTask.stacked ? 'text-decoration-line-through' : ''">
            <b>{{ bigTask.title }}</b><br />
            {{ bigTask. description}}
          </p>
          <p @click.prevent="editBigTask"
             class="click-edit-big-task ms-2 text-body-2 text-right text-red-lighten-3"
          ><i>Edit</i></p>
        </div>

      </v-card>
    </div>


    <!-- if no big task -->
    <div v-else>
      <v-textarea v-model="bigTaskTitle"
                  id="big-task-title-input"
                  variant="outlined" rows="1"
                  auto-grow
                  label="Big Task Title (required)"
      ></v-textarea>
      <v-textarea v-model="bigTaskDescription"
                  id="big-task-description-input"
                  variant="outlined" rows="3"
                  auto-grow
                  label="Big Task Description (optional)"
      ></v-textarea>
      <div class="d-flex" style="margin-top: -16px;"
           :class="bigTaskTitle || bigTaskDescription ? 'justify-space-between' : 'justify-end'"
      >
        <v-btn v-if="bigTaskTitle || bigTaskDescription" @click.prevent="deleteBigTask"
               class="px-2 text-capitalize"
               density="compact"
               color="red-lighten-3"
        >Delete Task</v-btn>
        <v-btn @click.prevent="saveBigTask"
               density="compact"
               class="px-2 text-capitalize"
               :class="bigTaskTitle ? 'bg-green-lighten-3' : ''"
               :disabled="!bigTaskTitle"
        >
          Update Big Task
        </v-btn>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
#section-big-task-for-today {
  .one-big-task { white-space: pre-line; }
  .click-edit-big-task:hover { cursor: pointer };
}
</style>
